import axios from "axios";
import { useMemo } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const token = await getToken();
      cfg.headers.Authorization = `Bearer ${token}`;
      return cfg;
    });
    return inst;
  }, [getToken]);
}

export const errMsg = (e, fallback = "Er ging iets mis. Probeer het opnieuw.") => {
  if (!e?.response) return "Geen verbinding met de server. Controleer je internet en probeer het opnieuw.";
  if (e.response.status === 401) return "Je sessie is verlopen. Log opnieuw in.";
  const d = e.response.data?.detail;
  if (typeof d === "string" && e.response.status < 500) return d;
  if (Array.isArray(d)) return "Niet alle velden zijn goed ingevuld. Controleer de gegevens.";
  if (e.response.status === 403) return "Je hebt hier geen rechten voor.";
  if (e.response.status >= 500) return "Er ging iets mis aan onze kant. Probeer het over een minuut opnieuw.";
  return fallback;
};

export const downloadBlob = (data, filename, type) => {
  const blob = data instanceof Blob ? data : new Blob([data], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
